import { HStack, VStack } from "@gluestack-ui/themed";
import { Text } from "@repo/core/components/core/Text";
import { ReportCardProps } from "../../types";
import { ReportCardEnum } from "@repo/core/types/reports";

export const AnalysedProposalsCard = ({
  period,
  bgColor = "$backgroundLight100",
  values,
  propsByVariant
}: ReportCardProps) => {
  const variantProps =
    propsByVariant as (typeof propsByVariant)[ReportCardEnum.ANALYSED_PROPOSALS];
  if (!variantProps) return null;
  return (
    <VStack
      w="$full"
      p="$4"
      bgColor={bgColor}
      borderBottomWidth={1}
      borderColor="$borderLight100"
    >
      <HStack>
        <VStack flex={1} gap={6}>
          <Text color="$textLight900" fontSize="$sm" fontWeight={600}>
            {period}
          </Text>

          <VStack>
            {values.map((value) => {
              return (
                <HStack alignItems="center" gap="$1">
                  {value.styles?.showIndicator && (
                    <VStack
                      h="$2"
                      w="$2"
                      bg={value.styles?.indicatorColor}
                      borderRadius="$full"
                    />
                  )}
                  <Text color="$textLight700" fontSize="$xs" fontWeight={500}>
                    {value.label} {value.value}
                  </Text>
                </HStack>
              );
            })}
          </VStack>
        </VStack>
        <VStack gap="$1" flex={1}>
          <HStack alignItems="center" justifyContent="flex-end">
            <Text color="$textLight700" fontSize="$xs" fontWeight={500}>
              Analisadas{" "}
            </Text>
            <Text color="$textLight700" fontSize="$xs" fontWeight={400}>
              {variantProps.totalAnalysed}
            </Text>
          </HStack>

          <HStack alignItems="center" justifyContent="flex-end">
            <Text color="$primary700" fontSize="$xs" fontWeight={500}>
              Aprovadas{" "}
            </Text>
            <Text color="$primary700" fontSize="$xs" fontWeight={400}>
              {variantProps.totalApproved}
            </Text>
          </HStack>

          <HStack alignItems="center" justifyContent="flex-end">
            <Text color="$primary700" fontSize="$xs" fontWeight={500}>
              Aprovadas Efetivadas{" "}
            </Text>
            <Text color="$primary700" fontSize="$xs" fontWeight={400}>
              {variantProps.totalApprovedEffective}
            </Text>
          </HStack>

          <HStack alignItems="center" justifyContent="flex-end">
            <Text color="$primary700" fontSize="$xs" fontWeight={500}>
              Contas ativadas{" "}
            </Text>
            <Text color="$primary700" fontSize="$xs" fontWeight={400}>
              {variantProps.totalApprovedEffective}
            </Text>
          </HStack>

          <HStack alignItems="center" justifyContent="flex-end">
            <Text color="$error600" fontSize="$xs" fontWeight={500}>
              Negadas{" "}
            </Text>
            <Text color="$error600" fontSize="$xs" fontWeight={400}>
              {variantProps.totalNegated}
            </Text>
          </HStack>
        </VStack>
      </HStack>
    </VStack>
  );
};
